/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import { next } from '@ember/runloop';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class ResourcingAnalysisRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: true,
      as: 'from',
    },
    dateTo: {
      refreshModel: true,
      as: 'to',
    },
    groupId: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let year = moment().year();
    let lastWeek = moment().subtract(1, 'week').format('YYYY-MM-DD');
    let today = moment().format('YYYY-MM-DD');
    let dateFrom = isEmpty(params.dateFrom) ? lastWeek : params.dateFrom;
    let dateTo = isEmpty(params.dateTo) ? today : params.dateTo;
    let groupId = params.groupId;

    return hash({
      records: this.store.query('attendance/record', {
        dateFrom,
        dateTo,
        groupId,
      }),
      groups: this.store.query('group', { year }),
      dates: this.store.query('date', {
        year: moment(dateFrom, 'YYYY-MM-DD').year(),
      }),
      // We need Enrolment records for all learners who attended at some point during the report period.
      // We don't currently have a way to filter for a date range, so just get 'em all.
      // TODO: make this more efficient.
      enrolments: this.store.findAll('people/enrolment'),
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.reset();
  }
}
